<template>
    <div class="risk-popup">
        <div v-if="riskType == $ms.constant.RiskCustomerVendorType.RiskInvoice || riskType == $ms.constant.RiskCustomerVendorType.NoneActivityAndRiskInvoce" >
            <div>{{focusTopMessage}}</div>
            <div class="bottom-text">{{textTopMessage}}<span class="view-detail-text" @click="showDetailDocument(referenceDocument)"> Xem chi tiết.</span></div>
        </div>
        <hr v-if="(riskType == $ms.constant.RiskCustomerVendorType.RiskInvoice || riskType == $ms.constant.RiskCustomerVendorType.NoneActivityAndRiskInvoce) && (riskType == $ms.constant.RiskCustomerVendorType.NoneActivity || riskType == $ms.constant.RiskCustomerVendorType.NoneActivityAndRiskInvoce)"/>
        <div class="bottom-text" v-if="riskType == $ms.constant.RiskCustomerVendorType.NoneActivity || riskType == $ms.constant.RiskCustomerVendorType.NoneActivityAndRiskInvoce">
            <div class="red-text">NNT ngừng hoạt động và đã đóng MST</div>
            <div>Ngày ngừng hoạt động: {{closedDateAlert}}</div>
            <div class="update-button">
                <div>Cập nhật lần cuối: {{currentDate}}</div>
                <span>
                    <ms-button
                        text="Tải lại"
                        leftIcon="refresh-black-big-blue"
                        class="refresh-button"
                        @click="reloadModifiedDate(taxCode)"
                    ></ms-button>
                </span>
                <!-- <span>Tải lại</span> -->
            </div>
            <div style="display: flex">Xem thông tin trên website của Tổng cục Thuế <div class="view-detail-text"><a class="has-link ml-1" target="_blank" :href="linkHelp($ms.constant.Help.GeneralDepartmentTax)">tại đây</a></div></div>
        </div>
    </div>
</template>
<script>
import {getCurrentInstance, onMounted, reactive, ref} from 'vue';
import moment from 'moment';
import integrationBIApi from '@/apis/integration/integrationBusinessInformationApi.js';
import popupUtil from '@/commons/popupUtil';

export default {
    props:{
        referenceDocument:{
            type: String
        },
        riskType: {
            type: Number
        },
        closedDate:{
            type: Date
        },
        riskWarningMessage:{
            type: Object
        },
        taxCode:{
            type: String
        },
        modifiedDate:{
            type: Date
        }
    },
    setup(props) {
        const focusTopMessage = ref('');
        const textTopMessage = ref('');
        const currentDate = ref(new Date('DD/MM/YYYY'));
        const closedDateAlert = ref('');
        const {proxy} = getCurrentInstance();
        onMounted(() => {
            const me = this;
            if(props.referenceDocument?.includes('Công văn số 1798/TCT-TTKT')){
                focusTopMessage.value = "Doanh nghiệp in, phát hành, mua bán trái phép hóa đơn";
                textTopMessage.value = "Theo văn bản: Công văn số 1798/TCT-TTKT.";
            } else if (props.referenceDocument?.includes('Công văn số 4729/CTHPH-TTKT1')){
                focusTopMessage.value = "Doanh nghiệp không hoạt động tại địa chỉ đăng ký kinh doanh, không có hóa đơn điện tử của hàng hóa dịch vụ mua vào, có rủi ro cao về thuế và hóa đơn";
                textTopMessage.value = "Theo văn bản: Công văn số 4729/CTHPH-TTKT1.";
            } else if (props.referenceDocument?.includes('Công văn số 2387/CCT-KT2')){
                focusTopMessage.value = "Doanh nghiệp in, phát hành, mua bán trái phép hóa đơn";
                textTopMessage.value = "Theo văn bản: Công văn số 2387/CCT-KT2.";
            }  else if (props.referenceDocument?.includes('Công văn số 12111/CTTPHCM-TTKT2')){
                focusTopMessage.value = "Doanh nghiệp bán hóa đơn";
                textTopMessage.value = "Theo văn bản: Công văn số 12111/CTTPHCM-TTKT2.";
            }
            closedDateAlert.value = moment(props.closedDate).format('DD/MM/YYYY');
            currentDate.value = new Date();
            currentDate.value = moment(props.modifiedDate).format('DD/MM/YYYY hh:mm');
        });
        async function reloadModifiedDate(taxCode) {
            // isRotate.value = true;
            try {
                await integrationBIApi.getBusinessInformationLookUp(taxCode.replace('-', '').replace(' ', ''), true).then(res => {
                currentDate.value = moment(res.modifiedDate).format('DD/MM/YYYY hh:mm');
                });
                // isRotate.value = false;
            } catch (error) {
            } finally {
                // isRotate.value = false;
            }
        }
        /**
         * Mở form công văn 1798
         * NBTIN 05.02.2024
         */
        function showDetailDocument(name){
            if(name){
                popupUtil.show('TADocumentPopup',{
                    mode: proxy.$ms.constant.FormState.View,
                    data: name
                });
            }
        
        }
        /**
		 * Gắn link help Tổng cục thuế
		 * NBTIN 02.01.2024
		 */
		function linkHelp(code, type) {
			type = type || 'mimosa';
			return window._misaHelp[code];
		};
        return {
            focusTopMessage,
            textTopMessage,
            closedDateAlert,
            currentDate,
            reloadModifiedDate,
            showDetailDocument,
            linkHelp,
        }
    },
}
</script>
<style lang="scss">
.risk-popup{
  width: 350px;
  height: auto;
  z-index: 10;
  position: absolute;
  left: 12%;
  background-color: $main-left-menu-border-color;
  padding: 8px;
  .bottom-text{
    color: white;
  }
  .red-text{
    color: $color-error;
  }
  button.ms-button.btn.primary.heightoptionvalue1.btn-border-none.refresh-button{
    background: $main-left-menu-border-color;
  }
  .update-button{
    display: flex;
    align-items: center;
    .refresh-button{
        color: $blue-text;
    }
  }
  .view-detail-text{
     color: $blue-text;
     cursor: pointer;
  }
}
</style>
